import { Card, CardContent, Stack } from "@mui/material";
import styles from './DeviceDetails.module.css'
import { Route, Routes } from "react-router-dom";
import Apps from "./Apps";
import Lics from "./Lics";
import Prefs from "./Prefs";
import Logs from "./Logs";
import Info from "./Info";

const empty = (total) => {
    return <Card sx={{maxHeight: '100%', display: 'flex', flexDirection: 'column'}}>
                <CardContent sx={{overflow: 'auto', display: 'flex', justifyContent: 'center'}}>
                    {total
                        ? <Stack sx={{whiteSpace: 'break-spaces'}}>Выберите кассу для получения дополнительной информации</Stack> 
                        : <Stack sx={{whiteSpace: 'break-spaces'}}>Подключите кассы к кабинету или измените настройки фильтра</Stack>}       
                </CardContent>
            </Card>
};

const DeviceDetails = ({item, total, profiles}) => {
    return (
        <div className={styles.details}>
            <div className={styles.content}>
                <Routes>
                    <Route path=":id/apps" element={<Apps />} />
                    <Route path=":id/lics" element={<Lics />} />
                    <Route path=":id/log" element={<Logs />} />
                    <Route path=":id/prefs" element={<Prefs profilesData={profiles} />} />
                    <Route path=":id/info" element={<Info info={item?.hwInfo} />} />
                    <Route path="" element={empty(total)} />
                </Routes>
                
            </div>    
        </div>
        
        
    );
};

export default DeviceDetails;